/**
 * Subscribes to `assistant:insight_updated` and invalidates the insights cache so
 * every one of a user's open sessions converges after a feedback/snooze (issue
 * #1090). The event payload carries no insight detail — the refetch goes through
 * the permission-checked API. Mount once in the assistant UI (AssistantPanel).
 */
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useWebSocket, type AssistantInsightUpdatedEvent } from './useWebSocket';
import { queryKeys } from './queryKeys';

export function useInsightRealtime(): void {
  const queryClient = useQueryClient();

  const onInsightUpdated = useCallback(
    (_data: AssistantInsightUpdatedEvent) => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.insights.all });
    },
    [queryClient],
  );

  useWebSocket('assistant:insight_updated', onInsightUpdated);
}
